export default class Erorrs {
	constructor(errors) {
		this.errors = errors
	}

	has(key) {
		if (this.errors != undefined && this.errors[key] != undefined) {
			return this.errors[key][0];
		}

		return false;
	}

	count() {
		return this.errors == undefined ? 0 : Object.keys(this.errors).length
	}
}